import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { marked } from 'marked';
import Seo from '../components/Seo';
import { Shell, articleClass } from '../components/Article';

// ponytail: hardcoded post list; generate from files if posts outgrow this
export const POSTS = [
  {
    slug: 'takt-time-vs-cycle-time',
    title: 'Takt time vs cycle time: the two numbers that run your line',
    description:
      'Takt time is the rhythm demand sets; cycle time is the pace your stations actually achieve. Confusing them hides bottlenecks and burns capacity.',
    date: 'July 24, 2026',
  },
  {
    slug: 'how-we-verify-ai-robot-programs',
    title: 'Can you trust AI-written robot programs?',
    description:
      'AI can write robot programs from a prompt. Whether you can run them depends on one thing: what checks them.',
    date: 'July 23, 2026',
  },
];

export const BlogIndex = () => (
  <Shell>
    <Seo
      title="Blog — Emboscale, The Factory Agent"
      description="Notes from the Factory Agent: factory layout planning, line balancing, shift scheduling, and verified AI robot programming."
      path="/blog"
    />
    <div className="font-mono text-xs tracking-[0.25em] uppercase text-emerald-600 dark:text-emerald-400 mt-10 mb-4">Blog</div>
    <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white mb-12">Notes from the Factory Agent</h1>
    <ul className="space-y-10">
      {POSTS.map((p) => (
        <li key={p.slug}>
          <Link to={`/blog/${p.slug}`} className="group block">
            <div className="font-mono text-xs text-gray-500 mb-2">{p.date}{p.draft ? ' · DRAFT' : ''}</div>
            <div className="text-2xl font-semibold text-gray-900 dark:text-white group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors duration-200 mb-2">
              {p.title}
            </div>
            <p className="text-gray-600 dark:text-gray-400">{p.description}</p>
          </Link>
        </li>
      ))}
    </ul>
  </Shell>
);

export const BlogPost = () => {
  const { slug } = useParams();
  const [html, setHtml] = useState(null);
  const meta = POSTS.find((p) => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`/blog/${slug}.md`)
      .then((r) => (r.ok ? r.text() : Promise.reject()))
      .then((md) => {
        const body = md.replace(/^---[\s\S]*?---\s*/, ''); // strip frontmatter
        setHtml(marked.parse(body));
      })
      .catch(() => setHtml('<p>Post not found.</p>'));
  }, [slug]);

  return (
    <Shell>
      {meta && (
        <Seo title={`${meta.title} — Emboscale`} description={meta.description} path={`/blog/${meta.slug}`} />
      )}
      {meta?.draft && (
        <div className="inline-block font-mono text-xs tracking-widest uppercase text-amber-400 border border-amber-400/40 rounded-full px-3 py-1 mt-10">
          Draft — not published
        </div>
      )}
      <article
        className={articleClass}
        dangerouslySetInnerHTML={html ? { __html: html } : undefined}
      >
        {html ? undefined : <p className="text-gray-500 mt-8">Loading…</p>}
      </article>
    </Shell>
  );
};
